export default __webpack_public_path__ + "static/media/first.2ab38d5b.jpeg";